import * as React from 'react';
import { IDocument } from '../../types/my-types';
import { useQueryClient } from '@tanstack/react-query';
import useGlynt from './useGlynt';

export default function useGetDocumentsWithMarks(documents: IDocument[], trainingSetId: string) {
  const client = useQueryClient();
  const glynt = useGlynt();
  const [marks, setMarks] = React.useState<{ documentId: string; count: number }[]>([]);
  const lastProcessedIdsRef = React.useRef<string>('');

  React.useEffect(() => {
    const currentIds = documents
      .map((doc) => doc.id)
      .sort()
      .join(',');

    // Only process if the document IDs have actually changed
    if (currentIds !== lastProcessedIdsRef.current) {
      lastProcessedIdsRef.current = currentIds;

      if (documents && documents.length > 0) {
        Promise.all(
          documents.map(async (doc: IDocument) => {
            return client
              .fetchQuery({
                queryKey: ['docGroundTruths', doc.id],
                queryFn: async () =>
                  (await glynt).groundTruths.list({
                    document: doc.id,
                    training_set: trainingSetId,
                    advanced: true,
                    exclude_empty: true,
                  }),
              })
              .then((data) => {
                return {
                  documentId: doc.id,
                  count: data.count,
                };
              });
          })
        )
          .then((result) => {
            setMarks(result);
          })
          .catch(console.error);
      } else {
        setMarks([]);
      }
    }
  }, [documents, client, trainingSetId, glynt]);

  return marks;
}
